import React, { FC } from 'react';
import styled from 'styled-components';

type Props = {
  setShowConfirmId: Function;
  onImageDeleted: Function;
  rowId: number;
  imageId: number;
};
const DeleteConfirmationPopup: FC<Props> = ({ setShowConfirmId, onImageDeleted, rowId, imageId }) => {
  const onDeleteClick = async e => {
    e.stopPropagation();
    e.preventDefault();

    onImageDeleted();
    await onImageDeleted({ itemId: rowId, id: imageId });
    setShowConfirmId(-1);
  };
  const onCancelClick = e => {
    e.stopPropagation();
    e.preventDefault();
    setShowConfirmId(-1);
  };
  return (
    <Wrapper>
      <div>Please confirm the Delete</div>
      <Buttons>
        <Button onClick={onCancelClick}>Cancel</Button>
        <Button onClick={onDeleteClick}>OK</Button>
      </Buttons>
    </Wrapper>
  );
};

export default DeleteConfirmationPopup;

const Buttons = styled.div`
  position: relative;
  display: flex;
  gap: 5px;
  margin-top: 25px;
`;

const Button = styled.div`
  font-size: 15px;
  width: 120px;
  border: 1px solid var(--primary);
  border-radius: 6px;
  cursor: pointer;
  &:hover {
    background-color: var(--border);
  }
`;
const Wrapper = styled.div`
  border: 2px solid var(--defaultTableCellTitle);
  border-radius: 6px;
  width: 255px;
  height: 98px;
  position: absolute;
  background-color: #fff;
  top: 0px;
  right: 31px;
  font-size: 19px;
  padding: 8px;
  text-align: center;
  box-shadow: 7px 7px var(--defaultTableCellTitle);
`;
